// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"26f2663c","239":"e1f9bc7a","453":"46f0fb3b","732":"f5ff6c02"}[chunkId] + ".chunk.js";
};